import React from 'react';
import { Rectangle } from './constants';
import { Layer, Rect } from 'react-konva';

interface Props {
  magnifyingRectangle: Rectangle;
}
const MagnifyingRectangle = (props: Props) => {
  const { magnifyingRectangle } = props;

  return (
    <>
      {magnifyingRectangle && (
        <Layer id='canvas-magnifyingrectangle-layer'>
          <Rect
            id='canvas-magnifyingrectangle-rect'
            x={magnifyingRectangle.x}
            y={magnifyingRectangle.y}
            width={magnifyingRectangle.width}
            height={magnifyingRectangle.height}
            stroke="red"
            dash={[4, 4]}
            strokeScaleEnabled={false}
          />
        </Layer>
      )}
    </>
  );
};

export default MagnifyingRectangle;
